"use client";

import type { TradingPeriodMessage } from "@cronika/proto/common/trading_pb";
import { lazy, Suspense } from "react";

const TradingChartLazy = lazy(() => import("./TradingChart"));

const ChartFallback = () => (
  <div className="relative h-full w-full flex items-center justify-center">
    <div className="flex flex-col items-center gap-3">
      <div className="w-12 h-12 border-4 border-[#f5a524] border-t-[grey] rounded-full animate-spin" />
      <span className="text-sm text-gray-400">Loading chart...</span>
    </div>
  </div>
);

type TradingChartWrapperProps = {
  selectedTimePeriod?: TradingPeriodMessage;
  selectedTimePeriodSeconds?: number;
  hoveredButton?: "call" | "put" | null;
  mobileBottomOffset?: number;
};

const TradingChartWrapper: React.FC<TradingChartWrapperProps> = ({
  selectedTimePeriod,
  selectedTimePeriodSeconds,
  hoveredButton,
  mobileBottomOffset,
}) => (
  <Suspense fallback={<ChartFallback />}>
    <TradingChartLazy
      selectedTimePeriod={selectedTimePeriod}
      selectedTimePeriodSeconds={selectedTimePeriodSeconds}
      hoveredButton={hoveredButton}
      mobileBottomOffset={mobileBottomOffset}
    />
  </Suspense>
);

export default TradingChartWrapper;
